document.addEventListener('DOMContentLoaded', () => {
  // 1. ジャンプボタン
  const navItems = document.querySelectorAll('.page-event-nav-item');
  navItems.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      const targetId = btn.getAttribute('href');
      const target = document.querySelector(targetId);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // 2. PCメニュー表示・非表示
  const side = document.querySelector('.page-event-side-wrap');
  
  // ★ターゲットを '-main' ではなく、一つ外側の大枠に変更（より安全です）
  const content = document.querySelector('.page-event-lp'); 

  if (side && content) {
    // フッターの手前などで消したい場合の調整値
    const END_OFFSET = 0;

    document.addEventListener('scroll', () => {
      const scrollY = window.scrollY; // 画面の一番上の位置

      // ★絶対位置を getBoundingClientRect() で直接取得する
      const rect = content.getBoundingClientRect();
      const contentTop = rect.top + scrollY;
      const contentBottom = rect.bottom + scrollY - END_OFFSET; // ←ここを修正
      const scrollBottom = window.scrollY + window.innerHeight;

      // activeをつける条件（画面のトップが、コンテンツの上端〜下端の間にいる時）
      side.classList.toggle('active', scrollY >= contentTop && scrollBottom <= contentBottom);
    });
  }

  // 3. Swiper (要素がある時だけ実行)
  if (document.querySelector('.page-event-cpn-swiper')) {
    new Swiper('.page-event-cpn-swiper', {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  // 1. 開くボタン（data-targetを持つすべての要素）を取得
  const openBtns = document.querySelectorAll('[data-target]');
  
  // 2. 閉じる対象のクラス名（配列で管理しておくと楽です）
  const closeSelector = '.page-event-popup__close-txt, .page-event-popup__close-btn';

  // --- 関数: ポップアップを開く ---
  const openPopup = (targetId) => {
    const targetPopup = document.querySelector(targetId);
    if (targetPopup) {
      targetPopup.classList.add('is-active');
      document.body.classList.add('no-scroll'); // 背景固定
    }
  };

  // --- 関数: ポップアップを閉じる ---
  const closePopup = (popupElement) => {
    popupElement.classList.remove('is-active');
    document.body.classList.remove('no-scroll'); // 背景固定解除
  };

  // --- イベント設定: 開くボタン ---
  openBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault(); // リンク遷移を無効化
      const targetId = btn.getAttribute('data-target');
      openPopup(targetId);
    });
  });

  // --- イベント設定: 閉じるボタン ---
  // ページ内のすべてのポップアップに対して処理を設定
  const popups = document.querySelectorAll('.page-event-popup');
  
  popups.forEach((popup) => {
    // そのポップアップ内の「閉じるボタン」たちを探す
    const closeElements = popup.querySelectorAll(closeSelector);
    
    closeElements.forEach((closeBtn) => {
      closeBtn.addEventListener('click', () => {
        closePopup(popup);
      });
    });

    // (オプション) 背景の黒い部分をクリックしても閉じたい場合
    popup.addEventListener('click', (e) => {
      // クリックされたのがポップアップの背景（自分自身）なら閉じる
      if (e.target === popup) {
        closePopup(popup);
      }
    });
  });

  // ------------------------------------------------
  // ▼▼▼ 修正版：スクロール連動（絶対位置計算） ▼▼▼
  // ------------------------------------------------
  
  const spyLinks = document.querySelectorAll('.page-event-nav-item');
  
  // 反応するタイミングの調整
  // 数値が大きいほど「早めに（下にあるうちに）」反応します。
  // 「もっと遅らせたい」場合は、この数値を小さくしてください（例: 100 や 50）
  const SPY_OFFSET = 100; 

  // 要素の「ページ最上部からの絶対位置」を正確に測る関数
  const getAbsoluteTop = (element) => {
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  };

  const updateScrollSpy = () => {
    const scrollY = window.scrollY;

    // まず全てのactiveを消す（親も含めてリセット）
    spyLinks.forEach(link => link.classList.remove('active'));

    // 現在アクティブにすべきリンクの候補を探す
    let currentLink = null;

    spyLinks.forEach((link) => {
      const targetId = link.getAttribute('href');
      if (!targetId || targetId === '#' || targetId.indexOf('#') === -1) return;

      const target = document.querySelector(targetId);
      
      if (target) {
        // ここで絶対位置を使用
        const targetTop = getAbsoluteTop(target) - SPY_OFFSET;
        const targetBottom = targetTop + target.offsetHeight;

        // 範囲内に入っているかチェック
        if (scrollY >= targetTop && scrollY < targetBottom) {
          // 該当するものを一時保存
          // ※ ネストしている場合、内側の詳細な方（子）を優先させたい場合、
          // ループ順序によっては上書きが必要ですが、
          // 今回の構造なら「範囲に入っているもの」にクラスをつける方式でOK
          link.classList.add('active');
          
          // 親メニューも光らせる処理
          const parentLi = link.closest('.page-event-nav-list-item');
          if (parentLi) {
             // 直下の親リンクを探す（ulの兄弟にあるaタグなど構造に合わせて調整）
             // あなたのHTML構造では li > a と li > ul > li > a なので、
             // .page-event-nav-list-item 直下の a を探せばOK
             const parentLink = parentLi.querySelector(':scope > .page-event-nav-item');
             if (parentLink) {
               parentLink.classList.add('active');
             }
          }
        }
      }
    });
  };

  window.addEventListener('scroll', updateScrollSpy);
  updateScrollSpy();
});